import api from './api';

const inFlightGets = new Map();

const stableParams = (params) => {
  if (!params) return '';
  return JSON.stringify(Object.keys(params).sort().reduce((acc, key) => {
    acc[key] = params[key];
    return acc;
  }, {}));
};

export const dedupedGet = (url, config = {}) => {
  const key = `${url}|${stableParams(config.params)}`;
  if (inFlightGets.has(key)) return inFlightGets.get(key);

  const request = api.get(url, config).finally(() => {
    inFlightGets.delete(key);
  });
  inFlightGets.set(key, request);
  return request;
};

export default dedupedGet;
